import i18n from '@/i18n'
import {
  SetupContext,
  watch,
  ref,
  getCurrentInstance
} from '@vue/composition-api'
import { appealByFid } from '@/services/api'
import type { appealParam } from './interface'
import type { illegalAppealPropsType } from '../props'
const appealSetup = (props: illegalAppealPropsType, context: SetupContext) => {
  const vm = getCurrentInstance()
  const inputText = ref('')
  const hasError = ref(false)
  const errMsg = ref('')
  const dialogText = {
    title: i18n.t('309ec43078'),
    txt1Before: i18n.t('6479ccd94a'),
    txt1After: i18n.t('fc4e48a17a'),
    placeholder: i18n.t('58f69ca425'),
    btnText: i18n.t('7b5fb662cc')
  }
  
  watch(inputText, (val) => {
    if (val.length >= 50) {
      hasError.value = true
      errMsg.value = i18n.t('06bff8a305')
    } else {
      hasError.value = false
      errMsg.value = ''
    }
  })
  const onOk = async () => {
    if (hasError.value) {
      return null
    }
    if (inputText.value.length <= 0) {
      if (props.isMobile) {
        (vm?.proxy as any)?.$toast?.(i18n.t('188c4f96ac'))
      } else {
        (vm?.proxy as any)?.$message?.warning?.(i18n.t('188c4f96ac'))
      }
      return null
    }
    if (inputText.value.length > 0 && inputText.value.length < 5) {
      if (props.isMobile) {
        (vm?.proxy as any)?.$toast?.(i18n.t('fba51b188e'))
      } else {
        (vm?.proxy as any)?.$message?.warning?.(i18n.t('fba51b188e'))
      }
      return null
    }
    // 提交申诉
    const params: appealParam = {
      kind: 3,
      comment: inputText.value
    }
    await appealByFid(props.fileId, params)
    props.afterAppeal?.()
  }
  return {
    inputText,
    hasError,
    errMsg,
    dialogText,
    onOk
  }
}
export default appealSetup
